import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SlideDeleteValidator from "./SlideDeleteValidator";
import DeleteNewIcon from "../../images/DeleteNewIcon.svg";
import {
  deleteSlidesRequest,
  deleteChildSlideFromMaster,
  updateModuleCardsinEditor
} from "../../services/apis";
import { toggleLeftPanel } from "../../utils/editorUtils/commonFunctions";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";

const SlideNextAndPrevious = ({
  slideID,
  setSlideID,
  currentSlide,
  setCurrentSlide,
  setSlideCount,
  editor,
  appData,
  childSlideCount,
  setChildSlideCount,
  loadSuccess,
  setLoadSuccess,
  setSaveLoading,
  slideCount,
}) => {
  let navigate = useNavigate();
  const [prompt, setPrompt] = useState(false);
  let list = [];
  const nextPage = async () => {
    if (!loadSuccess) return;
    setLoadSuccess(false);
    setSaveLoading(true);
    toggleLeftPanel();
    let currentPage = filterCurrentPage();
    let slideIDInstance = JSON.parse(JSON.stringify(slideID));
    if (currentPage < slideID.length - 1) {
      navigate(`/editor/${slideID[currentPage + 1].slideid?._id}`);
      setCurrentSlide({ master: slideIDInstance[currentPage + 1], child: {} });
      setSlideCount(currentPage + 2);
      // editor.editor.attributes.PageManager.select(
      //   slideID[currentPage + 1].slideid?._id
      // );
      setSlideID(slideIDInstance);
    } else if (currentPage === slideID.length - 1) return;
    toggleLeftPanel();
  };
  const filterCurrentPage = () => {
    return slideID.findIndex(
      (slide) => slide.slideid?._id === currentSlide.master.slideid?._id
    );
  };
  const previousPage = async () => {
    if (!loadSuccess) return;
    setLoadSuccess(false);
    setSaveLoading(true);

    let currentPage = filterCurrentPage();
    let slideIDInstance = JSON.parse(JSON.stringify(slideID));
    toggleLeftPanel();
    if (currentPage > 0) {
      navigate(`/editor/${slideID[currentPage - 1].slideid?._id}`);
      setCurrentSlide({ master: slideIDInstance[currentPage - 1], child: {} });
      setSlideCount(currentPage);
      setSlideID(slideIDInstance);
    } else if (currentPage === 0) {
      return;
    }
  };

  const getCurrentMasterSlideIndex = () => {
    return (
      slideID?.findIndex(
        (slide) => slide?.slideid?._id === currentSlide?.master?.slideid?._id
      ) + 1
    );
  };
  const validateDelete = () => {
    // if (
    //   slideID.length === 1 ||
    //   (JSON.stringify(currentSlide.child) !== "{}" &&
    //     currentSlide?.master?.children.length > 1)
    // )
    //   return;
    // if (JSON.stringify(currentSlide?.child) !== "{}")
    //   if (currentSlide?.master?.children?.length === 1) return;

    // setPrompt(slideID?.length > 1);
    setPrompt(
      JSON.stringify(currentSlide?.child) === "{}"
        ? slideID.length > 1
          ? true
          : false
        : true
    );
  };
  //new script
  const deleteChildSlide = () => {
    toggleLeftPanel();
    let currentPageIndex = currentSlide?.master?.children?.findIndex(
      (child) => child?.slideid?._id === currentSlide?.child?.slideid?._id
    );

    let tempCurrentSlide = JSON.parse(JSON.stringify(currentSlide));
    let deleteChildFromMasterPayload = {
      children: [currentSlide?.child?.slideid?._id],
    };
    deleteChildSlideFromMaster(
      appData.deckId._id,
      tempCurrentSlide?.master?.slideid?._id,
      deleteChildFromMasterPayload,
      async (response, err, errorCode) => {
        if (err) {
          showErrorToast('Slide deletion failed. Please try again.');
        } else {
          showSuccessToast('Slide deleted successfully.');
          let tempSLidesList = JSON.parse(JSON.stringify(slideID));
          if (tempCurrentSlide?.master?.children === 1) {
            tempCurrentSlide.master.children = [];
            tempCurrentSlide.child = {};
            navigate(`/editor/${tempCurrentSlide?.master?.slideid?._id}`);
          } else {
            tempCurrentSlide?.master?.children?.splice(currentPageIndex, 1);
            // sortSLidesAfterDelete(
            //   tempCurrentSlide?.master?.children,
            //   currentSlide.master.index - 1
            // );
            if (Array.isArray(tempCurrentSlide?.master?.children)) {
              tempCurrentSlide.master.children.forEach((child, idx) => {
                if (idx >= currentPageIndex && typeof child.index === 'number') {
                  child.index = child.index - 1;
                }
              });
            }
            tempCurrentSlide.child = {};
            navigate(`/editor/${tempCurrentSlide?.master?.slideid?._id}`);
          }
          setCurrentSlide(tempCurrentSlide);
          let currentIndex = slideID.findIndex(
            (slide) =>
              slide.slideid?._id === tempCurrentSlide.master.slideid?._id
          );
          tempSLidesList[currentIndex] = tempCurrentSlide.master;
          setSlideID(tempSLidesList);
          window.localStorage.setItem(
            "removedSlieId",
            currentSlide?.child?.slideid?._id
          );
        }
      }
    );
  };

  //end
  const sortSLidesAfterDelete = (tempSlideId, initVal) => {
    for (let i = initVal; i < tempSlideId.length; i++) {
      tempSlideId[i].index = i + 1;
    }
  };

  function getAllContentIds(components, ids = []) {
    components.forEach(comp => {
      const contentId = comp.getAttributes()['data-content-id'];

      if (contentId) {
        ids.push(contentId);
      }

      if (comp.components().length) {
        getAllContentIds(comp.components(), ids);
      }
    });

    return ids;
  }

  function decreaseMatchedCount(data, contentIds) {
    const idSet = new Set(contentIds);

    return data.map(item => {
      if (idSet.has(item.id)) {
        return {
          ...item,
          count: Math.max(0, item.count - 1)
        };
      }
      return item;
    });
  }
  function updateDBDeckContent(deckId, payload) {
    const payloadInput = {
      selected_module_data: payload,
    };
    return new Promise((resolve, reject) => {
      updateModuleCardsinEditor(deckId, payloadInput, (response, err) => {
        if (err) {
          reject(err);
        } else {
          resolve(response?.data?.response?.selected_module_data || []);
        }
      });
    });
  }
  const deleteSlide = () => {
    if (!loadSuccess) return;
    setLoadSuccess(false);
    setSaveLoading(true);
    setPrompt(false);
    if (JSON.stringify(currentSlide.child) !== "{}") {
      deleteChildSlide();
      return;
    }

    let currentPage = currentSlide.master.index - 1;
    deleteSlidesRequest(
      appData.deckId._id,
      slideID[currentPage].slideid?._id,
      async (response, err, errorCode) => {
        if (err) {
          showErrorToast('Deletion failed. Pl try again');
        } else {
          showSuccessToast('Deletion successful');
          const data = response.data;

          let tempSlideId = [...slideID];
          // let tempSlideId = [...response.data.slides];
          /* comment the code below due to runvalidation descope this will revert back the cleared components present on editor in validation popup */
          /* const contentIds = getAllContentIds(editor.getWrapper().components());
          const selected_module_data = appData?.deckId?.selected_module_data;
          const updatedData = decreaseMatchedCount(selected_module_data, contentIds);
          appData.setDeckId((prev) => ({
            ...prev,
            selected_module_data: updatedData,
          }));
          console.log(contentIds, 'editor content ids', updatedData);
          updateDBDeckContent(appData?.deckId?._id, updatedData); */

          if (currentPage > 0) {
            navigate(`/editor/${slideID[currentPage - 1].slideid?._id}`);
            tempSlideId.splice(currentPage, 1);
            sortSLidesAfterDelete(tempSlideId, currentSlide.master.index - 1);
            setSlideID(tempSlideId);
            setCurrentSlide({ master: slideID[currentPage - 1], child: {} });
            setSlideCount(currentPage);
          } else if (currentPage === 0) {
            navigate(`/editor/${slideID[currentPage + 1].slideid?._id}`);
            tempSlideId.shift();
            sortSLidesAfterDelete(tempSlideId, 0);
            setSlideID(tempSlideId);
            setCurrentSlide({ master: slideID[currentPage + 1], child: {} });
            setSlideCount(currentPage + 1);
          }
        }
      }
    );
  };
  const getClassName = () => {
    return JSON.stringify(currentSlide?.child) === "{}"
      ? slideID.length > 1
        ? "new-slide-delete-icon "
        : "disableDelete  "
      : "new-slide-delete-icon ";
  };
  const lastPage = () => {
    return slideID?.length > 0
      ? slideID[slideID.length - 1].slideid?._id ===
      currentSlide?.master?.slideid?._id
      : false;
  };
  const firstPage = () => {
    return slideID?.length > 0
      ? slideID[0].slideid?._id === currentSlide?.master?.slideid?._id
      : false;
  };
  return (
    <>
      <div
        onClick={validateDelete}
        className={getClassName() + "ignoreClick d-flex align-items-center"}
        style={{ display: "flex" }}
      >
        <img src={DeleteNewIcon} alt="Delete slide" className="ignoreClick" />
        <h2 className="ignoreClick">Delete Slide</h2>
        {/* <li>
          <img
            src={NewSlideLeftArrowIcon}
            className={firstPage() ? "disableNavigate" : "new-slide-left-icon"}
            style={{ cursor: "pointer" }}
            alt=""
            onClick={() => !firstPage() && previousPage("prev")}
          />
        </li>
        <li>
          <img
            src={NewSlideRightArrowIcon}
            className={lastPage() ? "disableNavigate" : "new-slide-right-icon"}
            style={{ cursor: "pointer" }}
            alt=""
            onClick={() => !lastPage() && nextPage("next")}
          />
        </li> */}
      </div>
      {prompt && (
        <SlideDeleteValidator
          prompt={prompt}
          setPrompt={setPrompt}
          deleteSlide={deleteSlide}
          nthSlide={
            JSON.stringify(currentSlide?.child) !== "{}"
              ? childSlideCount
              : slideCount
          }
          child={JSON.stringify(currentSlide?.child) !== "{}"}
        />
      )}
    </>
  );
};

export default SlideNextAndPrevious;
